export function reportSalesByProducts(idProduto, startDate, endDate) {
  const token = localStorage.getItem("token");
  const params = new URLSearchParams({
    auth: token,
    idProduto,
    startDate,
    endDate,
  });

  window.open(
    `${process.env.VUE_APP_URL_BACKEND}/report/produtos-vendas?${params.toString()}`
  );
}
